import _ from 'lodash';
import React, { useState, useMemo } from 'react';

export default function CheckboxGroup({ input, options, searchEnabled = false }) {
  const { name, onChange, onBlur, onFocus } = input;
  const [search, setSearch] = useState('');
  const debouncedSetSearch = useMemo(() => _.debounce(setSearch, 250), []);
  const inputValue = input.value;

  if (!options || !options.length) return null;

  const checkboxes = options.map(({ label, value, disabled }, index) => {
    if (search && !_.includes(_.toLower(label), _.toLower(search))) return null;

    const handleChange = (event) => {
      const arr = [...inputValue];
      if (event.target.checked) {
        arr.push(value);
      } else {
        arr.splice(arr.indexOf(value), 1);
      }
      onBlur(arr);
      return onChange(arr);
    };

    const checked = inputValue.includes(value);

    return (
      <label key={`checkbox-${index}`}>
        <input type="checkbox" name={`${name}[${index}]`} disabled={disabled} value={value} checked={checked} onChange={handleChange} onFocus={onFocus} />
        <span>{label}</span>
      </label>
    );
  });

  return (
    <div className="checkbox-inputs">
      { searchEnabled &&
        <input
          className="form-control border-none border-bottom"
          style={{
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
          }}
          placeholder="search"
          onChange={event => debouncedSetSearch(event.target.value)}
        />
      }
      <div className="px-3 py-2 border-rounded bg-white w-100 rounded overflow-scroll" style={{ maxHeight: 190 }}>
        {checkboxes}
      </div>
    </div>
  );
}
